import { Account, Action } from "@zapier/trials/src/types";

type Props = {
  action: Action;
  account: Account;
};

export const isAccountEligibleForAction = ({ account, action }: Props) => {
  if (action.conditions.isTrialingPro === true) {
    if (
      !account.isTrialing ||
      account.isTrialingCompanies ||
      account.isTrialingTeams
    )
      return false;
  }

  return true;
};
